<style lang="scss" scoped>
td.color-status-4 {
  span.badge.badge-secondary {
    background: #4f5d73;
    color: #ffffff;
  }
}

td.color-status-3 {
  span.badge.badge-secondary {
    background: #dc1313;
    color: #ffffff;
  }
}

td.color-status-2 {
  span.badge.badge-secondary {
    background: #006400;
    color: #ffffff;
  }
}
</style>
<template>
  <div class="time-sheet">
    <CCard class="filter">
      <CRow>
        <CCol col="12" sm="6" lg="3">
          <CRow class="mb-mobile-2 mb-tablet-3">
            <CCol col="12">
              <label>{{ $t("timeSheets.start_date") }}</label>
            </CCol>
            <CCol col="12">
              <DatePickerFormFlex
                :propsDate="searchData.start_date"
                @emitDate="startDate"
                v-model="searchData.start_date"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="3">
          <CRow class="py-sm-0 mb-mobile-2 mb-tablet-3">
            <CCol col="12">
              <label>{{ $t("timeSheets.end_date") }}</label>
            </CCol>
            <CCol col="12">
              <DatePickerFormFlex
                :propsDate="searchData.end_date"
                @emitDate="endDate"
                v-model="searchData.end_date"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="3">
          <CRow class="mb-mobile-2 mb-tablet-3">
            <CCol sm="12">
              <label>Foot</label>
            </CCol>
            <CCol sm="12">
              <select
                class="form-control form-group"
                v-model="searchData.foot_code"
                @change="search"
              >
                <option value="0">{{
                  $t("placeholder.label_employee_option_search")
                }}</option>
                <option
                  v-for="foot in foots"
                  :key="foot.id"
                  :value="foot.code"
                  >{{ foot.name }}</option
                >
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="3">
          <CRow class="mb-mobile-2 mb-tablet-3">
            <CCol sm="12">
              <label>{{ $t("label.division") }}</label>
            </CCol>
            <CCol sm="12">
              <select
                class="form-control form-group"
                v-model="searchData.division_code"
                @change="search"
              >
                <option value="0">{{
                  $t("placeholder.label_employee_option_search")
                }}</option>
                <option
                  v-for="division in filterDivision"
                  :key="division.id"
                  :value="division.code"
                  >{{ division.name }}
                </option>
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="3">
          <CRow class="mb-mobile-2 mb-tablet-3">
            <CCol sm="12">
              <label>{{ $t("timeSheets.id_name") }}</label>
            </CCol>
            <CCol sm="12">
              <CInput type="text" v-model="searchData.employee_info" />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="3">
          <CRow class="mb-mobile-2 mb-tablet-3">
            <CCol sm="12">
              <label>{{ $t("commons.label_approve_person") }}</label>
            </CCol>
            <CCol sm="12">
              <CInput type="text" v-model="searchData.approvePerson" />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="3">
          <CRow class="mb-mobile-2 mb-tablet-3">
            <CCol col="12">
              <label>{{ $t("label.status") }}</label>
            </CCol>
            <CCol col="12">
              <select
                class="form-control form-group"
                v-model="searchData.status"
                @change="search"
              >
                <option value="0">{{ $t("label.all") }}</option>
                <option
                  v-for="(item, index) in approvalStatus"
                  :key="index"
                  :value="item"
                  >{{ $t(`commons.label_status_approve_${item}`) }}
                </option>
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="3" class="btn-search text-center">
        <CButton class="btn-search-color" @click="search">{{
          $t("label.search")
        }}</CButton>
        <CButton class="btn-reset" @click="resetForm"
          >{{ $t("button.label_action_reset") }}
        </CButton>
        </CCol>
      </CRow>
    </CCard>
    <CCard class="filter1"  v-if="totalTimeSheetRequests.total > 0">
    <CRow style="margin-left: 0">
          <table class="table1">
                <th class="padding_table">Họ và tên </th>
                <th class="center">Người duyệt cấp 1</th>
                <th class="center">Người duyệt cấp 2</th>
              <tr v-for="(item, index) in totalTimeSheetRequests" :key="index">
                <td v-if="index != 'total' && index != ''" class="padding_table">{{index}}</td>
                <td v-if="index != 'total' && index != 0" class="center">{{item.level1}}</td>
                <td v-if="index != 'total' && index != 0" class="center">{{item.level2}}</td>
              </tr>
              <tr>
                <th class="padding_table">Tổng</th>
                <td colspan="2" class="center">{{totalTimeSheetRequests.total}}</td>
              </tr>
            </table>
      </CRow>
      </CCard>
    <div class="table-list">
      <CCard>
        <CCardBody>
          <div class="option-table">
            <div class="form-group">
              <select
                class="form-control"
                v-model="searchData.itemsPerPage"
                @change="search"
              >
                <option
                  v-for="item in listItemsPerPage"
                  :value="item"
                  :key="item"
                  >{{ item }}</option
                >
              </select>
            </div>
            <template
              v-if="
                additionalTimeSheets.data &&
                  additionalTimeSheets.data.length > 0
              "
            >
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ $t("commons.label_text_to") }} {{ searchData.paginate.to }}
                {{ $t("commons.label_text_of") }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
            <template v-else>
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ searchData.paginate.to }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
          </div>
          <div class="table-responsive">
            <table class="table table-mobile table-tablet">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ $t("label.employee_code") }}</th>
                  <th>{{ $t("label.full_name") }}</th>
                  <th>Foot</th>
                  <th>{{ $t("label.division") }}</th>
                  <th>{{ $t("additional_timeSheet.request_date") }}</th>
                  <th>{{ $t("label.start_time") }}</th>
                  <th>{{ $t("label.end_time") }}</th>
                  <th>{{ $t("label.reason") }}</th>
                  <th>{{ $t("label.confirm_information") }}</th>
                  <th>{{ $t("label.status") }}</th>
                  <th>{{ $t("label.action") }}</th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-if="
                    additionalTimeSheets.data &&
                      additionalTimeSheets.data.length > 0
                  "
                >
                  <tr
                    v-for="(additionalTimeSheet,
                    index) in additionalTimeSheets.data"
                    :key="additionalTimeSheet.id"
                  >
                    <th>{{ index + 1 }}</th>
                    <td>
                      {{
                        additionalTimeSheet.employee_id
                          ? additionalTimeSheet.employee_id
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        additionalTimeSheet.employee_name
                          ? additionalTimeSheet.employee_name
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        additionalTimeSheet.foot
                          ? additionalTimeSheet.foot
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        additionalTimeSheet.division
                          ? additionalTimeSheet.division
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        additionalTimeSheet.work_date
                          ? formatDate(additionalTimeSheet.work_date)
                          : "-"
                      }}
                    </td>
                    <td>
                      <template v-if="additionalTimeSheet.start_time_request">
                        {{
                          additionalTimeSheet.start_time_request | formatHour
                        }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="additionalTimeSheet.end_time_request">
                        {{ additionalTimeSheet.end_time_request | formatHour }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td class="reason-additional-timesheet">
                      {{
                        additionalTimeSheet.reason
                          ? additionalTimeSheet.reason
                          : "-"
                      }}
                    </td>
                    <td class="confirmation-notification">
                      <div
                        v-for="(item,
                        index) in additionalTimeSheet.request_approve"
                        :key="index"
                      >
                        <span v-if="item.status"
                          >- {{ item.approved_by }}:
                          {{
                            $t(`overtime.employee_approval_${item.status}`)
                          }}</span
                        >
                      </div>
                    </td>
                    <td
                      v-bind:class="
                        additionalTimeSheet.status
                          ? 'color-status-' + additionalTimeSheet.status
                          : ''
                      "
                    >
                      <CBadge color="secondary">
                        {{
                          $t(
                            `commons.label_status_approve_${additionalTimeSheet.status}`
                          )
                        }}
                      </CBadge>
                    </td>
                    <td>
                      <router-link
                        :to="{
                          path: `/additional-timesheet/detail/${additionalTimeSheet.id}`
                        }"
                      >
                        <CButton
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          >{{ $t("button.label_action_detail") }}
                        </CButton>
                      </router-link>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="13" class="text-center">
                      {{ $t("table.label_data_not_found") }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </CCardBody>
        <CPagination
          v-if="
            additionalTimeSheets.data && additionalTimeSheets.data.length > 0
          "
          :activePage.sync="searchData.paginate.currentPage"
          :pages="searchData.paginate.totalPage"
          @update:activePage="fetchAdditionalTimeSheetData"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";

export default {
  name: "AdditionalTimesheet",
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_timeSheet_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    DatePickerFormFlex
  },
  data() {
    return {
      searchData: {
        start_date: "",
        end_date: "",
        foot_code: 0,
        division_code: 0,
        employee_info: "",
        status: 0,
        approvePerson: "",
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      }
    };
  },
  created() {
    this.searchData.start_date = this.getDateSearch().firstDay;
    this.searchData.end_date = this.getDateSearch().lastDay;
    // this.getTimeSheetToday();
    this.fetchAdditionalTimeSheetData();
  },
  computed: {
    ...mapGetters({
      additionalTimeSheets: "additional-timesheet/additionalTimeSheets",
      pagination: "additional-timesheet/pagination",
      listItemsPerPage: "commons/listItemsPerPage",
      approvalStatus: "commons/approvalStatus",
      divisions: "commons/divisions",
      foots: "commons/foots",
      companies: "commons/companies",
      totalTimeSheetRequests: "additional-timesheet/totalTimeSheetRequests"
    }),
    filterDivision() {
      if (this.searchData.foot_code == "0") return this.divisions;
      return this.divisions.filter(
        division => division.parent_code === this.searchData.foot_code
      );
    }
  },
  methods: {
    ...mapActions("additional-timesheet", ["deleteAdditionalTimeSheet"]),
    ...mapActions("layout", ["setLoading"]),

    startDate(data) {
      this.searchData.start_date = data;
    },

    endDate(data) {
      this.searchData.end_date = data;
    },

    resetForm() {
      this.searchData.start_date = this.getDateSearch().firstDay;
      this.searchData.end_date = this.getDateSearch().lastDay;
      this.searchData.division_code = 0;
      this.searchData.employee_info = "";
      this.searchData.status = 0;
      this.searchData.foot_code = 0;
      this.searchData.approvePerson = "";
    },

    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
          moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
            "YYYY-MM-DD"
          )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: ""
      };
    },

    async fetchAdditionalTimeSheetData() {
      await this.$store.dispatch(
        "additional-timesheet/fetchAdditionalTimeSheet",
        {
          start_date: this.searchData.start_date,
          end_date: this.searchData.end_date,
          foot_code: this.searchData.foot_code,
          division_code: this.searchData.division_code,
          status: this.searchData.status,
          employee_info: this.searchData.employee_info,
          approvePerson: this.searchData.approvePerson,
          itemsPerPage: this.searchData.itemsPerPage,
          currentPage: this.searchData.paginate.currentPage
        }
      );
      this.searchData.paginate = this.pagination;
    },
    async search() {
      this.searchData.paginate.currentPage = 0;
      this.setLoading(true);
      try {
        await this.fetchAdditionalTimeSheetData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
    async deleteItem(overTimeRequestId) {
      this.$confirm(
        this.$t("popup.label_popup_text"),
        this.$t("popup.label_popup_title"),
        this.$t("popup.label_confirm_button"),
        this.$t("popup.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.deleteAdditionalTimeSheet(overTimeRequestId)
            .then(() => {
              this.fetchAdditionalTimeSheetData();
              this.$toast(
                this.$t("popup.label_popup_success_text"),
                null,
                2000,
                "b-toaster-top-center",
                "success"
              );
            })
            .catch(() => {
              this.$toast(
                this.$t("popup.label_popup_error_text"),
                null,
                2000,
                "b-toaster-top-center",
                "error"
              );
            });
        }
      });
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.center{
  text-align: center;
}
.padding_table{
  padding: 0 5px;
}
.table1{
    background: #f8f8f8;
    width: 50%;
    th,
    td{
      padding: 5px;
      border:1px solid #d8dbe0;
    }
}
.btn-search {
    margin-top: 25px;
}
.search-box {
  padding-top: 13px;
  text-align: center;
}

.filter1 {
  margin: 1rem -2rem 0rem -2rem;
  padding: 2rem;
}
.filter {
  margin: -2rem -2rem 0rem -2rem;
  padding: 2rem;
}

.table-list {
  margin-top: 1rem;
}

tr.day-off {
  background-color: #f0f8ff;
}

th,
td {
  vertical-align: middle !important;
}

.required {
  color: #dc1313;
  font-size: 13px;
}

.option-table {
  display: flex;
  justify-content: space-between;
}

.btn-search-timesheet {
  background-color: #b5dbf2;
  padding: 8px;
  width: 120px;
}

.reason-additional-timesheet {
  max-width: 240px;
}
.confirmation-notification {
  min-width: 200px;
}
@media only screen and (max-device-width: 767px) {
  .card-body {
    padding: 0.25rem;
  }
  .show-text-table {
    margin-top: 0.4rem;
  }
  select.form-control.form-group {
    margin: 0;
  }
  .form-group {
    margin: 0;
  }
  .option-table {
    padding: 0.25rem;
    margin-bottom: 20px;
  }
  .table-mobile {
    width: 1500px;
    overflow-x: scroll;
  }
  .mb-mobile-2 {
    margin-bottom: 0.5rem;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1500px;
    overflow-x: scroll;
  }
  .mb-tablet-3 {
    margin-bottom: 1.5rem;
  }
}
</style>
